export enum GroupPlatform {
  Wintrado = 'WINTRADO',
  MT5 = 'MT5',
}

export interface IGroup {
  id: number;
  name: string;
  platform: GroupPlatform;
  createdAt: Date;
  depositCurrency: string;
  leverage: number;
  routingAdapterName: string;
  disableSwapCharges: boolean;
  fttId: number;
}

/**
 * A group as configured on the MT5 server, returned by GET /api/admin/groups/mt5. Distinct from
 * IGroup on purpose: there is no local id, and MT5 has no per-group leverage (leverage is a
 * per-user attribute there), so neither field is invented here.
 */
export interface IMt5Group {
  group: string;
  currency: string;
  currencyDigits: number;
  company: string;
}

export interface ITradeCommission {
  groupId: string;
  symbol: string;
  open: string | number;
  close: string | number;
}

export interface ISwap {
  groupId: string;
  symbol: string;
  swapMode: SwapModesEnum;
  swapLong: string | number;
  swapShort: string | number;
  swap3DayWeekday: number | null;
}

export interface IGroupRowData {
  symbol: string;
  bid: number;
  ask: number;
  open: string | number;
  close: string | number;
  swapMode: SwapModesEnum;
  swapLong: string | number;
  swapShort: string | number;
  swap3DayWeekday: number | null;
  expanded?: boolean;
}

export interface IAddNewGroup {
  name: string;
  leverage: string;
  currency: string;
  adapterName: string;
  disableSwapCharges: boolean;
}

export interface IEditGroupProps {
  currentGroup: IGroup | null;
  hideEditGroup: (refetch?: boolean) => void;
}

export interface ICreateGroupProps {
  show: boolean;
  hideAddGroup: (refetch?: boolean) => void;
}

export enum SwapModesEnum {
  DISABLED = 'DISABLED',
  POINTS = 'POINTS',
}

export const swapModes = [
  { value: 'DISABLED', label: 'DISABLED' },
  { value: 'POINTS', label: 'POINTS' },
];

export const swapDays = [
  { value: 0, label: 'SUNDAY' },
  { value: 1, label: 'MONDAY' },
  { value: 2, label: 'TUESDAY' },
  { value: 3, label: 'WEDNESDAY' },
  { value: 4, label: 'THURSDAY' },
  { value: 5, label: 'FRIDAY' },
  { value: 6, label: 'SATURDAY' },
  { value: null, label: 'NONE' },
];

export interface ISymbolConfigurationForGroup {
  swapMode: SwapModesEnum;
  swapLong: number;
  swapShort: number;
  swap3DayWeekday: number | undefined;
}
